/**
 * 购买过程
 * @author zhenn
 * @time 2016-11-16
 */
import React, {Component} from 'react';
import url from 'c-url';
import native from 'c-up-native';
import loading from 'c-up-loading';

import Search from '../search/upcode';
import OrderView from '../orderview/index';
import cache from '../global/cache';
import ProfileService from './profile.service';

class Process extends Component {

    componentWillMount() {
        const self = this;
        // 在uplive app中，将自动通过协议和数据接口获取用户upcode，不用输入upcode号码在uplive中先取用户信息 
        let isInUpliveApp = native.getPlatform() === 'uplive';
        if (isInUpliveApp) {
            loading.show();

            this.setState({
                waitingUpcode: true
            });

            native.getConfigs({
                invalid: 1,
                complete: confs => {
                    const { uid, usertoken } = confs;
                    // console.log(JSON.stringify(confs));

                    ProfileService.fetchProfile(uid, usertoken).then( profileInfo => {
                        loading.hide();

                        cache.setCache('userInfo', profileInfo);

                        this.setState( prevState => {
                            return {
                                ...prevState,
                                step: 'order',
                                userInfo: profileInfo,
                                waitingUpcode: false
                            };
                        });
                    }, (err) => {
                        loading.hide();
                        // 出现处理错误，将回退到原输入模式
                        this.setState({
                            step: 'search',
                            waitingUpcode: false
                        });
                    });
                },
                errtip: () => {
                    loading.hide();
                    // 出现处理错误，将回退到原输入模式
                    this.setState({
                        step: 'search',
                        waitingUpcode: false
                    });
                }
            });
        } else {
            let userInfo = cache.getCache('userInfo');
            if (userInfo) {
                this.setState({
                    step:  'order',
                    userInfo
                });
            } else {
                this.setState({
                    step: 'search'
                });

            }

            
        }

        if (url.query('upcode')) {
            this.setState({
                step: 'search'
            });
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            step: 'search',
            userInfo: {}
        };
    }

    onChangeAccount() {
        cache.removeCache('userInfo');
        this.setState({
            step: 'search'
        });
    }

    searchSuccess(res) {
        console.log(res)
        this.setState({
            step: 'order',
            userInfo: res
        });
    }

    render() {
        if (this.state.waitingUpcode) {
            return (<div></div>);
        }

        return this.state.step == 'search' ? (
                <Search searchSuccess={this.searchSuccess.bind(this)} />
        ) : (
                <OrderView {...this.state} onChangeAccount={this.onChangeAccount.bind(this)} />
        );
    }
}

export default Process;




// WEBPACK FOOTER //
// ./js/process/index.js